import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DatepickerRange } from '../standalones/components/date-range-picker/date-range-picker.component';
import { DatepickerRangeName } from '../services/date-range-picker-constants.service';

@Pipe({
  name: 'dateRangePickerSelection',
})
export class DateRangePickerSelectionPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(datepickerRange: DatepickerRange): string {
    let activeRangeText = datepickerRange.name;

    if (datepickerRange.name === DatepickerRangeName.CUSTOM) {
      activeRangeText += `: ${moment(datepickerRange.range.start).format('DD-MM-YYYY')} - ${moment(
        datepickerRange.range.end,
      ).format('DD-MM-YYYY')}`;
    }
    return this.translate.instant(activeRangeText);
  }
}
